/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';

import { t } from '../../providers';
import VerticalMenu from '../VerticalMenu';
import ApplicationsTableHeader from './ApplicationsTableHeader';

const useStyles = makeStyles((_theme) => ({
    actions: {
        width: '3%',
    },
    tableContainer: {
        minHeight: '200px',
        '@media (max-width:960px)': {
            width: 'calc(100vw - 80px)',
        },
    },
    imageCell: {
        textAlign: 'center',
        height: '40px',
    },
    notValidApp: {
        backgroundColor: '#F5C6CB',
    },
}));

const ApplicationsTable = ({
    sortBy = '',
    sortType = '',
    setSorting = () => {},
    applications,
    tableId = 'applicationsTable',
    notValidApplications = [],
}) => {
    const classes = useStyles();

    const tableHead = (
        <ApplicationsTableHeader setSorting={setSorting} sortBy={sortBy} sortType={sortType} headers={applications.headers || []} tableId={tableId} />
    );

    const isInvalidApplication = (app) => {
        // application id
        const appId = app.filter((item) => item.label === 'application.id').map((item) => item.value);
        // find out if app is invalid
        return !!appId.length && notValidApplications.some((ele) => ele === appId[0]);
    };

    return (
        <TableContainer className={classes.tableContainer}>
            <Grid item xs={12}>
                {applications && applications.headers && applications.headers.length > 0 && (
                    <Table id={`table-${tableId}`} className={classes.table} aria-label="simple table">
                        {tableHead}
                        <TableBody>
                            {(!applications.data || applications.data.length === 0 && tableId !== 'myDrafts') && (
                                <TableRow className={classes.row}>
                                    <TableCell colSpan={applications.headers.length} align="center">
                                        {t('no.applications')}
                                    </TableCell>
                                </TableRow>
                            )}
                            {(!applications.data || applications.data.length === 0 && tableId === 'myDrafts') && (
                                <TableRow className={classes.row}>
                                    <TableCell colSpan={applications.headers.length} align="center">
                                        {t('no.drafts')}
                                    </TableCell>
                                </TableRow>
                            )}
                            {(applications.data || []).map((app, appIdx) => {
                                const notValidApp = isInvalidApplication(app);
                                return (
                                    <TableRow key={appIdx} className={notValidApp ? classes.notValidApp : ''}>
                                        {app.map((item, idx) => {
                                            const cellClass = item.label === 'graphicalRepresentation' ? classes.imageCell : '';
                                            return (
                                                <React.Fragment key={idx}>
                                                    {item.label !== 'application.id' && (
                                                        <React.Fragment>
                                                            {item.label === 'menuItems' ? (
                                                                <TableCell className={classes.actions} align={item.align || 'left'}>
                                                                    <VerticalMenu
                                                                        actionButtonId={`${tableId}-table-actionButton-${appIdx}`}
                                                                        menuItems={item.value}
                                                                    />
                                                                </TableCell>
                                                            ) : (
                                                                <TableCell align={item.align || 'left'} className={cellClass}>
                                                                    {item.value}
                                                                </TableCell>
                                                            )}
                                                        </React.Fragment>
                                                    )}
                                                </React.Fragment>
                                            );
                                        })}
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                )}
            </Grid>
        </TableContainer>
    );
};

export default ApplicationsTable;
